import { makeStyles } from "tss-react/mui";

import { Theme } from "@mui/material";

export const useStyles = makeStyles()((theme: Theme) => ({
    content: {
        flex: 1,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(1),
        gap: theme.spacing(3),
    },
    staticSection: {
        display: "flex",
        flexDirection: "column",
        flex: "none",
        gap: theme.spacing(1),
    },
    devicesSection: {
        display: "flex",
        flexDirection: "column",
        flex: 1,
        minHeight: 0,
        gap: theme.spacing(1),
    },
    footer: {
        display: "flex",
        justifyContent: "space-between",
        gap: theme.spacing(1),
        padding: theme.spacing(2, 3),
        borderTop: `1px solid ${theme.palette.emteria.border.primary}`,
        flexShrink: 0,
    },
    disabledButtonWrapper: {
        display: "inline-flex",
    },
}));
